import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiVisa} from "../../api-services/shared";
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { Observable } from "rxjs";
import { MkpSellerOrderContainerModel } from '../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class SellerOrderService extends BaseApiTemplateService<MkpSellerOrderContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/seller-orders/login-merchant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/seller-orders/login-merchant-ep';
    this.httpClient = http;
  }
  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string
  ): Observable<Blob> {
    let params;
    let url;
    if (customParam) {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid);
      // .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid);
    }
    url =
      apiVisa.api_domain_url + this.endpoint_path + "/print-jasper-pdf/" + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
}